import http from "./http";
let request = "/api";

// 解密大行动
export function jiemidaxingdong() {}
//当前教育机构人才信息模糊查询
export function educationResumeInfoFuzzyQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentInfo/educationResumeInfoFuzzyQuery",
    params
  );
}
//当前教育机构下用户信息查询
export function educationUserInfoQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentInfo/educationUserInfoQuery",
    params
  );
} //当前教育机构人才信息查询
export function educationResumeInfoQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentInfo/educationResumeInfoQuery",
    params
  );
}
//修改人才状态
export function resumeUpdateStatus(params) {
  return http.get(
    "/modules-parent/educationalInstitutionTalentInfo/resumeUpdateStatus",
    params
  );
}
//教育机构管理员查询当前机构用户
export function eduAdminQueryUsers(params) {
  return http.get(
    "/modules-parent/educationalInstitutionPost/eduAdminQueryUsers",
    params
  );
}
// 获取验证码
export function identifyCodeImg(params) {
  return http.get("/modules-parent/login/identifyCodeImg", params);
}
// 管理员登录
export function platformAdminLogin(params) {
  return http.post("/modules-parent/login/platformAdminLogin", params);
}

// 平台管理员用户新增
export function addAdminInfo(params) {
  return http.post("/modules-parent/platformAdminUser/addAdminInfo", params);
}
// 平台管理员用户新增new
export function addUser(params) {
  return http.post("/modules-parent/userInfo/addUser", params);
}
// 管理员用户全部查询
export function queryAllUserInfo(params) {
  return http.post(
    "/modules-parent/platformAdminUser/queryAllUserInfo",
    params
  );
}

// 批量删除平台管理员用户
export function batchDelete(params) {
  return http.post("/modules-parent/platformAdminUser/batchDelete", params);
}

// 平台管理员用户模糊查询
export function fuzzyQueryUserInfo(params) {
  return http.post(
    "/modules-parent/platformAdminUser/fuzzyQueryUserInfo",
    params
  );
}

// 平台管理员用户状态变更
export function stateChanges(params) {
  return http.post("/modules-parent/platformAdminUser/stateChanges", params);
}

//管理员用户重置密码
export function resetPassword(params) {
  return http.post("/modules-parent/platformAdminUser/resetPassword", params);
}

// 新增医疗机构信息
export function addMedicalInstitutionInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/addMedicalInstitutionInfo",
    params
  );
}

// 平台管理员查询医疗机构详细信息
export function queryMedicalInstitutionDetailInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/queryMedicalInstitutionDetailInfo",
    params
  );
}

// 修改医疗机构审核状态
export function updateMedicalInstitutionStatus(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/updateMedicalInstitutionStatus",
    params
  );
}

// 修改教育机构审核状态
export function educationAuditUpdate(params) {
  return http.post(
    "/modules-parent/educationInfoQuery/educationAuditUpdate",
    params
  );
}

// 删除医疗机构用户
export function deleteMedicalInstitutionUserInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/deleteMedicalInstitutionUserInfo",
    params
  );
}

//删除指定医疗机构接口
export function deleteMedicalInstitution(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/deleteMedicalInstitution",
    params
  );
}

// 删除数据字典
export function deleteDataDictionary(params) {
  return http.post(
    "/modules-parent/dataDictionary/deleteDataDictionary",
    params
  );
}

// 修改数据项状态
export function updateDataItemStatus(params) {
  return http.post(
    "/modules-parent/dataDictionary/updateDataItemStatus",
    params
  );
}

//管理员用户修改
export function updateAdminInfo(params) {
  return http.post("/modules-parent/platformAdminUser/updateAdminInfo", params);
}

//显示求人案件和学校信息
export function showInformation(params) {
  return http.post("/modules-parent/notLoggedInStatus/showInformation", params);
}

// 平台管理员消息基础查看接口
export function messageBaseQuery(params) {
  return http.post(
    "/modules-parent/messageBaseControl/messageBaseQuery",
    params
  );
}
// 平台管理员  消息删除接口
export function messageDelete(params) {
  return http.post("/modules-parent/messageBaseControl/messageDelete", params);
}

//平台管理员 消息模糊查询接口
export function messageFuzzyQuery(params) {
  return http.post(
    "/modules-parent/messageBaseControl/messageFuzzyQuery",
    params
  );
}
// 平台管理员用户全部查询
export function queryAllUserInfoAdmin(params) {
  return http.post(
    "/modules-parent/platformAdminUser/queryAllUserInfo",
    params
  );
}
// 批量删除平台管理员用户
export function batchDeleteInfoAdmin(params) {
  return http.post("/modules-parent/platformAdminUser/batchDelete", params);
}
// 平台管理员用户状态变更
export function stateChangesInfoAdmin(params) {
  return http.post("/modules-parent/platformAdminUser/stateChanges", params);
}
// 平台管理员用户状态列表获取
export function getDateItem(params) {
  return http.get("/modules-parent/common/getDateItem", params);
}
//平台管理员用户模糊查询
export function fuzzyQueryUserInfoAdmin(params) {
  return http.post(
    "/modules-parent/platformAdminUser/fuzzyQueryUserInfo",
    params
  );
}
// 图片上传到s3
export function uploadPictureToS3(params) {
  return http.post("/modules-parent/upload/uploadPictureToS3", params);
}
// 图片上传到oss
export function uploadPictureToOSS(params) {
  return http.post("/modules-parent/upload/uploadPictureToOSS", params);
}
//用户登录
export function userLogin(params) {
  return http.post("/modules-parent/login/userLogin", params);
}
//找回密码
export function retrievePassword(params) {
  return http.post("/modules-parent/login/retrievePassword", params);
}
//查询教育机构下人才信息
export function adminResumeInfoQuery(params) {
  return http.post("/modules-parent/resumeOperation/resumeInfoQuery", params);
}
//应聘人才信息模糊查询
export function fuzzyApplyResumeInfo(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/fuzzyApplyResumeInfo",
    params
  );
}
//重置密码
export function userResetPassword(params) {
  return http.get("/modules-parent/login/resetPassword", params);
}
//找回密码token校验
export function checkToken(params) {
  return http.get("/modules-parent/login/checkToken", params);
}

//查询人才信息
export function resumeQuery(params) {
  return http.get(
    "/modules-parent/educationalInstitutionTalentInfo/resumeQuery",
    params
  );
}

//模糊匹配案件信息和医疗机构信息
export function fuzzyCaseAndMedicalQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentSquare/fuzzyCaseAndMedicalQuery",
    params
  );
}
//查询求人案件信息(详情)
export function findPersonCaseDetailsQuery(params) {
  return http.get(
    "/modules-parent/educationalInstitutionTalentSquare/findPersonCaseDetailsQuery",
    params
  );
}
//医疗机构信息查询(详情)
export function medicalInstitutionDetailsQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentSquare/medicalInstitutionDetailsQuery",
    params
  );
}
//医疗机构信息查询(模糊)
export function fuzzyJobByMedicalId(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentSquare/fuzzyJobByMedicalId",
    params
  );
}
//申请人数
export function getApplyNumber(params) {
  return http.get("/modules-parent/dataPanel/applyNumber", params);
}

//医疗机构数
export function getMedicalNumber(params) {
  return http.get("/modules-parent/dataPanel/medicalNumber", params);
}
// 教育机构数
export function getEducationNumber(params) {
  return http.get("/modules-parent/dataPanel/educationNumber", params);
}
//人才数
export function getPersonnelNumber(params) {
  return http.get("/modules-parent/dataPanel/personnelNumber", params);
}
//求人案件数
export function getRecruitNumber(params) {
  return http.get("/modules-parent/dataPanel/recruitNumber", params);
}
//处理事项
export function handleMatter(params) {
  return http.get("/modules-parent/dataPanel/handleMatter", params);
}
//获取角色对应目录
export function getRoleDir(params) {
  return http.get("/modules-parent/common/getRoleDir", params);
}

//查询求人案件信息(列表)
export function findPersonCaseListQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentSquare/findPersonCaseListQuery",
    params
  );
}
//医疗机构信息查询(列表)
export function medicalInstitutionListQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentSquare/medicalInstitutionListQuery",
    params
  );
}

//招聘案件基本信息查询
export function jobCaseBasisQuery(params) {
  return http.post("/modules-parent/caseReview/jobCaseBasisQuery", params);
}
// 新增医疗机构用户
export function addMedicalInstitutionUserInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/addMedicalInstitutionUserInfo",
    params
  );
}
// 新增数据字典
export function insertDataDictionary(params) {
  return http.post(
    "/modules-parent/dataDictionary/insertDataDictionary",
    params
  );
}

// 修改数据字典
export function updateDataDictionary(params) {
  return http.post(
    "/modules-parent/dataDictionary/updateDataDictionary",
    params
  );
}
// 查询学校信息（列表）
export function schoolListQuery(params) {
  return http.post(
    "/modules-parent/medicalInstitutionTalentSquare/schoolListQuery",
    params
  );
}
// 查询学校信息（详情）
export function schoolDetailsQuery(params) {
  return http.post(
    "/modules-parent/medicalInstitutionTalentSquare/schoolDetailsQuery",
    params
  );
}
// 查询人才信息（列表）
export function talentListQuery(params) {
  return http.post(
    "/modules-parent/medicalInstitutionTalentSquare/talentListQuery",
    params
  );
}

//数据字典查询
export function queryDataDictionary(params) {
  return http.post(
    "/modules-parent/dataDictionary/queryDataDictionary",
    params
  );
}

//数据字典模糊查询
export function queryFUzzyDataDictionary(params) {
  return http.post(
    "/modules-parent/dataDictionary/queryFUzzyDataDictionary\n",
    params
  );
}
//医疗首页模糊查询
export function fuzzyCaseAndMedicalQuery2(params) {
  return http.post(
    "/modules-parent/medicalInstitutionTalentSquare/fuzzyCaseAndMedicalQuery",
    params
  );
}
// 修改数据项名称接口
export function updateDataItemName(params) {
  return http.post("/modules-parent/dataDictionary/updateDataItemName", params);
}

//数据字典查询数据项接口
export function queryDataItem(params) {
  return http.post("/modules-parent/dataDictionary/queryDataItem", params);
}
//求人信息添加保存接口
export function saveJobInfo(params) {
  return http.post("/modules-parent/medicalJobInfo/saveJobInfo", params);
}
//教育机构模糊查询接口
export function educationInfoFuzzyQuery(params) {
  return http.post(
    "/modules-parent/educationInfoQuery/educationInfoFuzzyQuery",
    params
  );
}

//教育机构查询
export function educationInfoQuery(params) {
  return http.post(
    "/modules-parent/educationInfoQuery/educationInfoQuery",
    params
  );
}

//删除教育机构
export function educationDelete(params) {
  return http.delete(
    "/modules-parent/educationInfoQuery/educationDelete",
    params
  );
}

//新增教育机构
export function educationInsert(params) {
  return http.post(
    "/modules-parent/educationInfoQuery/educationInsert",
    params
  );
}

//医疗和教育机构人员查询
export function medicalAndEducationUserQuery(params) {
  return http.post(
    "/modules-parent/platformAdminUser/medicalAndEducationUserQuery",
    params
  );
}
// oss图片回显
export function getUrlFromOSS(params) {
  return http.post("/modules-parent/upload/getUrlFromOSS", params);
}
//互动消息
export function messageShow(params) {
  return http.get("/modules-parent/dataPanel/messageShow", params);
}

//查询所有岗位信息
export function queryAll(params) {
  return http.post("/modules-parent/jobInfo/queryAll", params);
}

//岗位信息删除
export function deleteJobInfo(params) {
  return http.delete("/modules-parent/jobInfo/deleteJobInfo", params);
}

//岗位信息模糊查询
export function fuzzyQuery(params) {
  return http.post("/modules-parent/jobInfo/fuzzyQuery", params);
}

//管理员人才查询
export function allPersonnelQuery(params) {
  return http.post("/modules-parent/personnelQuery/allPersonnelQuery", params);
}
// 管理员人才模糊查询
export function fuzzyPersonnelQuery(params) {
  return http.post(
    "/modules-parent/personnelQuery/fuzzyPersonnelQuery",
    params
  );
}

//教育或用户登陆下认证教育机构查询接口
export function queryInstitutional(params) {
  return http.post("/modules-parent/advancedAuth/queryInstitutional", params);
}

//医疗机构求人案件删除接口
export function medicalJobInfoDeleteJobInfo(params) {
  return http.post("/modules-parent/medicalJobInfo/deleteJobInfo", params);
}

//求人信息发布接口
export function releaseJobInfo(params) {
  return http.post("/modules-parent/medicalJobInfo/releaseJobInfo", params);
}

//求人信息修改接口
export function updateJobInfo(params) {
  return http.post("/modules-parent/medicalJobInfo/updateJobInfo", params);
}
//平台管理员求人信息修改接口
export function adminUpdateJobInfo(params) {
  return http.post("/modules-parent/jobInfo/updateJobInfo", params);
}

//医疗机构管理查看求人信息模糊查询接口1
export function fuzzySelectJobInfo(params) {
  return http.post("/modules-parent/medicalJobInfo/fuzzySelectJobInfo", params);
}

//医疗机构管理查看求人信息接口1
export function selectJobInfo(params) {
  return http.post("/modules-parent/medicalJobInfo/selectJobInfo", params);
}

//医疗机构普通账户查看自身发布的岗位信息接口1
export function selectMyJobInfo(params) {
  return http.post("/modules-parent/medicalJobInfo/selectMyJobInfo", params);
}

//根据机关id查询学校信息
export function educationalInstitutionDisplay(params) {
  return http.post(
    "/modules-parent/notLoggedInStatus/educationalInstitutionDisplay",
    params
  );
}

//用户变更案件状态接口
export function userUpdateJobStatus(params) {
  return http.post(
    "/modules-parent/medicalJobInfo/userUpdateJobStatus",
    params
  );
}

//管理者当前医疗机构下用户信息查询接口
export function selectMedicalInstitutionUser(params) {
  return http.post(
    "/modules-parent/medicalJobInfo/selectMedicalInstitutionUser",
    params
  );
}

//管理者修改担当着求人案件担当者接口
export function updateJobPerson(params) {
  return http.post("/modules-parent/medicalJobInfo/updateJobPerson", params);
}
//管理者变更案件状态接口
export function updateJobStatus(params) {
  return http.post("/modules-parent/medicalJobInfo/updateJobStatus", params);
}

//根据岗位id查询求人案件信息
export function recruitmentInformationDetails(params) {
  return http.post(
    "/modules-parent/notLoggedInStatus/recruitmentInformationDetails",
    params
  );
}

//根据模糊参数查询学校和求人案件信息
export function informationFuzzyQuery(params) {
  return http.post(
    "/modules-parent/notLoggedInStatus/informationFuzzyQuery",
    params
  );
}

//查询所有未绑定教育机构的用户
export function queryEducationUser(params) {
  return http.post("/modules-parent/userInfo/queryEducationUser", params);
}

//查询所有未绑定医疗机构的用户
export function queryMedicalUser(params) {
  return http.post("/modules-parent/userInfo/queryMedicalUser", params);
}

//未做页面分隔符

//查询所有有应聘进度
export function queryAllApplyJob(params) {
  return http.post("/modules-parent/progress/queryAllApplyJob", params);
}

//查询某一案件应聘进度 or 所属岗位应聘信息
export function medicalApplyJob(params) {
  return http.post(
    "/modules-parent/recruitmentProgress/medicalApplyJob",
    params
  );
}

//教育机构下所有应聘信息查询
export function eduApplyJob(params) {
  return http.post("/modules-parent/applicationProgress/eduApplyJob", params);
}

//删除应聘进度
export function deleteApplyJob(params) {
  return http.post("/modules-parent/progress/deleteApplyJob", params);
}

//模糊查询应聘进度
export function fuzzyApplyJob(params) {
  return http.post("/modules-parent/progress/fuzzyApplyJob", params);
}

//新增应聘进度
export function insertApplyJob(params) {
  return http.post("/modules-parent/progress/insertApplyJob", params);
}

//修改应聘进度状态
export function updateAdminReviewStatus(params) {
  return http.post("/modules-parent/progress/updateAdminReviewStatus", params);
}

//修改应聘进度状态之管理员应聘管理
export function updateApplyStatus(params) {
  return http.post("/modules-parent/progress/updateApplyStatus", params);
}
//修改应聘进度
export function updateApplyJob(params) {
  return http.post("/modules-parent/progress/updateApplyJob", params);
}

//查询所有有所有有招聘进度的岗位信息
export function queryAllJob(params) {
  return http.post("/modules-parent/recruitmentProgress/queryAllJob", params);
}

//医疗机构收藏教育机构查询
export function queryMedicalCollectioneducation(params) {
  return http.post(
    "/modules-parent/MedicalCollection/queryMedicalCollectionEducation",
    params
  );
}
//医疗机构收藏教育机构模糊查询
export function queryFuzzyMedicalCollectioneducation(params) {
  return http.post(
    "/modules-parent/MedicalCollection/queryFuzzyMedicalCollectioneducation",
    params
  );
}
//医疗机构取消收藏教育机构
export function deleteMedicalCollectionEducation(params) {
  return http.post(
    "/modules-parent/MedicalCollection/deleteMedicalCollectionEducation",
    params
  );
}

//医疗机构收藏人才查询
export function queryMedicalCollectionPerson(params) {
  return http.post(
    "/modules-parent/MedicalCollection/queryMedicalCollectionPerson",
    params
  );
}
//医疗机构收藏应聘表查询
export function queryMedicalCollectionApplyjob(params) {
  return http.post(
    "/modules-parent/MedicalCollection/queryMedicalCollectionApplyjob",
    params
  );
}
//医疗机构收藏人才模糊查询
export function queryFuzzyMedicalCollectionPerson(params) {
  return http.post(
    "/modules-parent/MedicalCollection/queryFuzzyMedicalCollectionPerson",
    params
  );
}
//医疗机构取消收藏人才
export function deleteMedicalCollectionPerson(params) {
  return http.post(
    "/modules-parent/MedicalCollection/deleteMedicalCollectionPerson",
    params
  );
}
//医疗机构模糊查询收藏简历表
export function queryFuzzyMedicalCollectionApplyjob(params) {
  return http.post(
    "/modules-parent/MedicalCollection/queryFuzzyMedicalCollectionApplyjob",
    params
  );
}
//医疗机构取消收藏简历
export function deleteMedicalCollectionApplyJob(params) {
  return http.post(
    "/modules-parent/MedicalCollection/deleteMedicalCollectionApplyJob",
    params
  );
}
//教育机构收藏案件
export function selectJobCollect(params) {
  return http.post("/modules-parent/educationCollect/selectJobCollect", params);
}
//教育机构简历查询模糊
export function fuzzySelectJobCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/fuzzySelectJobCollect",
    params
  );
}
//教育机构简历批量删除
export function deleteJobCollect(params) {
  return http.post("/modules-parent/educationCollect/deleteJobCollect", params);
}
//医疗机构简历详情查看接口
export function medicalResumeDetailInfo(params) {
  return http.post(
    "/modules-parent/medicalResume/medicalResumeDetailInfo",
    params
  );
}

//医疗机构
export function queryMedicalInstitutionStatus(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/queryMedicalInstitutionStatus",
    params
  );
}
//求人信息修改
export function resumeUpdateInfo(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentInfo/resumeUpdateInfo",
    params
  );
}
//应聘人才信息查询
export function queryApplyResumeInfo(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/queryApplyResumeInfo",
    params
  );
}
//人才信息修改
export function resumeInfoUpdate(params) {
  return http.post("/modules-parent/resumeOperation/resumeInfoUpdate", params);
}

//通过应聘信息获取当前人才信息接口
export function selectResumeInfoByApplyJobId(params) {
  return http.post(
    "/modules-parent/medicalApplyJob/selectResumeInfoByApplyJobId",
    params
  );
}

//案件信息和应聘信息获取人才列表
export function getResumeByApplication(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/getResumeByApplication",
    params
  );
}
//应聘信息获取当前案件信息
export function getJobByApplication(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/getJobByApplication",
    params
  );
}

//当前教育机构有应聘信息的用户
export function queryResumeByJobId(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/queryResumeByJobId",
    params
  );
}

//修改人才担当者
export function resumeResponsibleUpdate(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentInfo/resumeResponsibleUpdate",
    params
  );
}
//人才信息详情查看
export function resumeDetailQuery(params) {
  return http.get(
    "/modules-parent/educationalInstitutionTalentInfo/resumeDetailQuery",
    params
  );
}
//查看自身发布的人才信息
export function resumeInfoQuery(params) {
  return http.get(
    "/modules-parent/educationalInstitutionTalentInfo/resumeInfoQuery",
    params
  );
}
//管理员查询教育机构详细信息
export function educationDetailQuery(params) {
  return http.get(
    "/modules-parent/educationInfoQuery/educationDetailQuery",
    params
  );
}

//基本信息查询
export function queryBasicInfo(params) {
  return http.post("/modules-parent/basicFunction/queryBasicInfo", params);
}

//查询教育机构下人才信息
export function educateResumeInfoQuery(params) {
  return http.get("/modules-parent/resumeOperation/resumeInfoQuery", params);
}
//收藏医疗机构删除接口
export function deleteMedicalCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/deleteMedicalCollect",
    params
  );
}
//收藏列表医疗机构模糊查询接口
export function fuzzySelectMedicalInstitutionCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/fuzzySelectMedicalInstitutionCollect",
    params
  );
}
//收藏列表医疗机构查询接口
export function selectMedicalInstitutionCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/selectMedicalInstitutionCollect",
    params
  );
}

//医疗查询案件详情
export function jobInfoQuery(params) {
  return http.post(
    "/modules-parent/educationalInstitutionPost/jobInfoQuery",
    params
  );
}

//新增认证
export function addInstitutionInfo(params) {
  return http.post("/modules-parent/advancedAuth/addInstitutionInfo", params);
}

//修改机构信息
export function editBasicInfo(params) {
  return http.post(" /modules-parent/basicFunction/editBasicInfo", params);
}

//变更人才状态信息
export function resumeStatusUpdate(params) {
  return http.get(
    "/modules-parent/educationalQuery/resumeStatusUpdate",
    params
  );
}

//全部应聘案件显示列表
export function queryAllApplyJob1(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/queryAllApplyJob",
    params
  );
}
//查询医疗机构所属员工信息
export function queryMedicalInstitutionUserInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/queryMedicalInstitutionUserInfo",
    params
  );
}

//查询教育机构下的人才信息
export function queryEducationPerson(params) {
  return http.post(
    "/modules-parent/educationalQuery/queryEducationPerson",
    params
  );
}
// 删除教育机构用户
export function deleteEducationPerson(params) {
  return http.delete(
    "/modules-parent/educationalQuery/deleteEducationPerson",
    params
  );
}
//新增教育机构用户
export function InsertEducationPerson(params) {
  return http.post(
    "/modules-parent/educationalQuery/InsertEducationPerson",
    params
  );
}
//修改教育机构用户
export function updateEducationPerson(params) {
  return http.post(
    "/modules-parent/educationalQuery/updateEducationPerson",
    params
  );
}
//人才信息添加保存接口(管理员)
export function adminResumeAddLaunch(params) {
  return http.post("/modules-parent/personnelQuery/resumeAddLaunch", params);
}
//人才信息添加保存接口
export function resumeAdd(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentInfo/resumeAdd",
    params
  );
}
//人才信息添加保存接口
export function adminResumeAdd(params) {
  return http.post("/modules-parent/personnelQuery/resumeAdd", params);
}
//人才信息添加保存接口
export function resumeAddLaunch(params) {
  return http.post(
    "/modules-parent/educationalInstitutionTalentInfo/resumeAddLaunch",
    params
  );
}

//应聘信息绑定
export function applicationInfoBinding(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/applicationInfoBinding",
    params
  );
}

//教育收藏应聘信息
export function selectApplyJobCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/selectApplyJobCollect",
    params
  );
}
//教育批量删除应聘信息
export function deleteApplyJobCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/deleteApplyJobCollect",
    params
  );
}
//教育收藏应聘信息模糊查询
export function fuzzySelectApplyJobCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/fuzzySelectApplyJobCollect",
    params
  );
}

//医疗管理员员工浏览
export function educationUserQueryEducationUser(params) {
  return http.post("/modules-parent/educationUser/queryEducationUser", params);
}
//教育管理员员工浏览
export function medicalUserqueryeMedicalUser(params) {
  return http.post("/modules-parent/medicalUser/queryeMedicalUser", params);
}
export function systemMsgShow(params) {
  return http.get("/modules-parent/dataPanel/systemMsgShow", params);
}
//更新医疗机构用户
export function updateMedicalInstitutionUserInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/updateMedicalInstitutionUserInfo",
    params
  );
}
//用户注册
export function userRegister(params) {
  return http.post("/modules-parent/register/userRegister", params);
}

//医疗机构管理员-修改医疗机构用户
export function updateMedicalUser(params) {
  return http.post("/modules-parent/medicalUser/updateMedicalUser", params);
}

//教育机构管理员-修改教育机构用户
export function updatEeducationUser(params) {
  return http.post("/modules-parent/educationUser/updatEeducationUser", params);
}
//教育机构管理员员工新增接口
export function addEducationUser(params) {
  return http.post("/modules-parent/educationUser/addEducationUser", params);
}

//医疗机构管理员员工新增接口
export function addMedicalUser(params) {
  return http.post("/modules-parent/medicalUser/addMedicalUser", params);
}
//新增数据字典数据项字典
export function insertDataItem(params) {
  return http.post("/modules-parent/dataDictionary/insertDataItem", params);
}

//修改数据项编码接口
export function updateDataItemCode(params) {
  return http.post("/modules-parent/dataDictionary/updateDataItemCode", params);
}

export function medicalFindAllApplyPerson(params) {
  return http.post(
    "/modules-parent/medicalApplyJob/medicalFindAllApplyPerson",
    params
  );
}
//应聘信息模糊查询接口
export function fuzzySelectApplyJob(params) {
  return http.post(
    "/modules-parent/medicalApplyJob/fuzzySelectApplyJob",
    params
  );
}
//案件应聘情况查询接口
export function selectApplyJobByJobId(params) {
  return http.post(
    "/modules-parent/medicalApplyJob/selectApplyJobByJobId",
    params
  );
}

//修改医疗机构开放状态
export function updateMedicalInstitutionOpenStatus(params) {
  return http.post(
    "/modules-parent/medicalInstitutionManagement/updateMedicalInstitutionOpenStatus",
    params
  );
}

//修改教育机构开放状态
export function educationOpenUpdate(params) {
  return http.post(
    "/modules-parent/educationInfoQuery/educationOpenUpdate",
    params
  );
}
//邮箱验证
export function registerVerifyEmail(params) {
  return http.get("/modules-parent/register/registerVerifyEmail", params);
}
//新增
//平台管理员审核通过
export function updateAdminReview(params) {
  return http.post("/modules-parent/progressReview/updateAdminReview", params);
}

export function medicalFuzzyFindAllApplyPerson(params) {
  return http.post(
    "/modules-parent/medicalApplyJob/medicalFuzzyFindAllApplyPerson",
    params
  );
}

//全部应聘案件显示列表模糊查询
export function fuzzyAllApplyJob(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/fuzzyAllApplyJob",
    params
  );
}

//岗位信息状态变更
export function jobInfoStatusChange(params) {
  return http.post("/modules-parent/jobInfo/jobInfoStatusChange", params);
}

//管理员停用机构用户
export function deadStatusEducationUser(params) {
  return http.post(
    "/modules-parent/educationalQuery/ deadStatusEducationUser",
    params
  );
}
//模糊查询当前教育机构应聘信息的用户
export function fuzzyResumeByJobId(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/fuzzyResumeByJobId",
    params
  );
}

export function resumeApplyJob(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/resumeApplyJob",
    params
  );
}
export function fuzzyResumeApplyJob(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/fuzzyResumeApplyJob",
    params
  );
}
//教育机构添加收藏
export function addEducationCollect(params) {
  return http.post(
    "/modules-parent/educationCollect/addEducationCollect",
    params
  );
}

//删除人才管理
export function personnelBatchDelete(params) {
  return http.delete(
    "/modules-parent/personnelQuery/personnelBatchDelete",
    params
  );
}
//医疗机构添加收藏
export function insertMedicalCollection(params) {
  return http.post(
    "/modules-parent/MedicalCollection/insertMedicalCollection",
    params
  );
}
//通过人才信息和应聘信息获取案件列表接口
export function getJobInfoByResumeIdAndApplyId(params) {
  return http.post(
    "/modules-parent/medicalApplyJob/getJobInfoByResumeIdAndApplyId",
    params
  );
}
// 应聘状态查询接口
export function applyStatusQuery(params) {
  return http.post("/modules-parent/medicalApplyJob/applyStatusQuery", params);
}

// 查询所有需要审核的应聘信息
export function progressReviewQueryAllApplyJob(params) {
  return http.post("/modules-parent/progressReview/queryAllApplyJob", params);
}
// 医疗机构通过人员查看所有应聘案件接口
export function getJobInfoByResumeId(params) {
  return http.post(
    "/modules-parent/medicalApplyJob/getJobInfoByResumeId",
    params
  );
}
//

//批量修改数据项状态
export function batchChangeStatus(params) {
  return http.post("/modules-parent/dataDictionary/batchChangeStatus", params);
}

//模糊查询医疗机构信息
export function fuzzyQueryMedicalInstitutionInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitution/fuzzyQueryMedicalInstitutionInfo",
    params
  );
}
//人才信息修改
export function adminResumeUpdateInfo(params) {
  return http.post("/modules-parent/personnelQuery/resumeUpdateInfo", params);
}
//查询当前机构下的人才信息
export function educationalQueryPersonnel(params) {
  return http.post(
    "/modules-parent/educationalQuery/educationalQueryPersonnel",
    params
  );
}
//平台管理员人才详情查询
export function personnelDetailQuery(params) {
  return http.get(
    "/modules-parent/personnelQuery/personnelDetailQuery",
    params
  );
}
//查询指定机构的所有员工
export function queryAppointInsAllUser(params) {
  return http.post("/modules-parent/userInfo/queryAppointInsAllUser", params);
}

//教育机构应聘状态查询
export function educationalGetApplyStatus(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/getApplyStatus",
    params
  );
}

// 教育机构应聘状态修改
export function educationalUpdateApplyStatus(params) {
  return http.post(
    "/modules-parent/eduApplicationManagement/updateApplyStatus",
    params
  );
}
// 医疗机构应聘状态修改接口
export function applyMedicalStatusUpdate(params) {
  return http.post("/modules-parent/medicalApplyJob/applyStatusUpdate", params);
}

// 查询医疗机构所有信息或输入医疗机构Id指定查询
export function queryMedicalInstitutionInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitution/queryMedicalInstitutionInfo",
    params
  );
}

// 收藏查询
export function collectionQuery(params) {
  return http.post(
    "/modules-parent/collectionManagement/collectionQuery",
    params
  );
}
// 求人信息详情查看接口
export function selectJobDetailInfo(params) {
  return http.post(
    "/modules-parent/medicalJobInfo/selectJobDetailInfo",
    params
  );
}

// 模糊查看教育机构用户
export function fuzzyQueryEducationUser(params) {
  return http.post(
    "/modules-parent/educationUser/fuzzyQueryEducationUser",
    params
  );
}
// 模糊查看教育机构用户
export function fuzzyQueryAllApplyJob(params) {
  return http.post(
    "/modules-parent/progressReview/fuzzyQueryAllApplyJob",
    params
  );
}
//平台管理员用户修改
export function updateAdminInfoAdmin(params) {
  return http.post("/modules-parent/platformAdminUser/updateAdminInfo", params);
}

//查询未审核应聘案件信息
export function jobCaseApplyQuery(params) {
  return http.post("/modules-parent/caseApply/jobCaseApplyQuery", params);
}

//管理员查询机构
export function queryAllInstitution(params) {
  return http.post("/modules-parent/userInfo/queryAllInstitution", params);
}

//查询新申请绑定的用户和原来机构的用户
export function queryApplyBindingOrgan(params) {
  return http.post(
    "/modules-parent/educationUser/queryApplyBindingOrgan",
    params
  );
}
// 教育机构管理员添加用户绑定
export function addUserBindingOrgan(params) {
  return http.get("/modules-parent/educationUser/addUserBindingOrgan", params);
}

//模糊查询新申请绑定的用户和原来机构的用户
export function fuzzyQueryInstitutional(params) {
  return http.post(
    "/modules-parent/advancedAuth/fuzzyQueryInstitutional",
    params
  );
}

//修改医疗机构信息
export function updateMedicalInstitutionInfo(params) {
  return http.post(
    "/modules-parent/medicalInstitution/updateMedicalInstitutionInfo",
    params
  );
}
//管理员新增收藏接口
export function collectionInsert(params) {
  return http.post(
    "/modules-parent/collectionManagement/collectionInsert",
    params
  );
}
// 用户注册邮箱验证
// export function registerVerifyEmail(params){
//     return http.get('/modules-parent/register/registerVerifyEmail',params)
// }

// // get请求
// export function getListAPI(params){
//     return http.get('/getList.json',params)
// }
// // post请求
// export function postFormAPI(params){
//     return http.post('/postForm.json',params)
// }

// // put 请求
// export function putSomeAPI(params){
//     return http.put('/putSome.json',params)
// }

// // delete 请求
// export function deleteListAPI(params){
//     return http.delete('/deleteList.json',params)
// }



// WEBPACK FOOTER //
// ./src/js/api.js